import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

export default function Roleredirect() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/login");
      return;
    }

    try {
      const decoded = jwtDecode(token);

      // Provera isteka tokena
      const now = Date.now() / 1000;
      if (decoded.exp && decoded.exp < now) {
        localStorage.removeItem("token");
        navigate("/login");
        return;
      }

      // Provera role
      if (decoded.role === "administrator") {
        navigate("/admin");
      } 
      else if (decoded.role === "finansije") {
        navigate("/finansije");
      }
      else if (decoded.role === "klijent") {
        navigate("/user");
      } 
      else {
        navigate("/error");
      }

    } catch (err) {
      localStorage.removeItem("token");
      navigate("/login");
    }

  }, [navigate]);

  return null; // ništa ne renderuje
}